export default __webpack_public_path__ + "static/ay-support-content-product-updates-e63e23b4920030caad5ba3a32e25224b.svg";